{
  "id": "campaign-118",
  "name": "Regal Promenade",
  "seed": "campaign:118",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....UCCCCCCU.....",
    ".....UCCCCCCU.....",
    "...CCCCCCCCCCCC...",
    "..hCh..T..T..hCh..",
    "...C*........*C...",
    ".,.C*x.......*C...",
    ",,.C*........*C...",
    ".,TCT........TCT..",
    "x..C....ww....C...",
    "..BC....ww....CB..",
    "...C*X......X*C...",
    "...C*........*C...",
    "...C*........*C...",
    "...C....~.....C...",
    ",x.C....~.....C...",
    ",,.CCCCCCCCCCCC...",
    "..................",
    "S....x............"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 11,
      "y": 16
    },
    {
      "kind": "rabbit",
      "x": 9,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 6
    },
    {
      "kind": "rabbit",
      "x": 13,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 16,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 3
    },
    {
      "kind": "repair",
      "x": 0,
      "y": 9
    }
  ],
  "falls": [
    {
      "x": 12,
      "y": 10,
      "dir": "N",
      "at": 38,
      "length": 3
    },
    {
      "x": 5,
      "y": 10,
      "dir": "N",
      "at": 44,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 118,
  "biome": "estate",
  "par": {
    "reel": 8846,
    "push": 7719,
    "selfPropelled": 6954,
    "tractor": 5965,
    "zeroTurn": 5050,
    "fairway": 3044
  },
  "goldTime": {
    "reel": 8396,
    "push": 7277,
    "selfPropelled": 6714,
    "tractor": 5555,
    "zeroTurn": 4753,
    "fairway": 2846
  },
  "routeTries": {
    "par": {
      "reel": 10,
      "push": 0,
      "selfPropelled": 17,
      "tractor": 0,
      "zeroTurn": 3,
      "fairway": 17
    },
    "gold": {
      "reel": 25,
      "push": 25,
      "selfPropelled": 25,
      "tractor": 41,
      "zeroTurn": 25,
      "fairway": 31
    }
  }
}
